export const FETCH_INFOS_BEGIN = 'FETCH_INFOS_BEGIN';
export const FETCH_INFOS_SUCCESS = 'FETCH_INFOS_SUCCESS';
export const FETCH_INFOS_ERROR = 'FETCH_INFOS_ERROR';
export const ADD_INFO_SUCCESS = 'ADD_INFO_SUCCESS';
export const UPDATE_INFO_SUCCESS = 'UPDATE_INFO_SUCCESS';
export const DELETE_INFO_SUCCESS = 'DELETE_INFO_SUCCESS';
